import { render } from "./SimpleInput.vue?vue&type=template&id=b2ecabf4&ts=true"
import script from "./SimpleInput.vue?vue&type=script&lang=ts"
export * from "./SimpleInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__